export default "__VITE_ASSET__Dgdm7kZ5__"